// extracted by mini-css-extract-plugin
export default {"container":"page404_container__oBAym","left-section":"page404_left-section__ipCtr"};